import { Rich } from '@agendor/shared';
import { TimeSlot } from './booking-service';

export const formatPrice = (cents: number) => {
    return `R$ ${(cents / 100).toFixed(2).replace('.', ',')}`;
};

export const formatTime = (time: TimeSlot) =>
    `${String(time.hour).padStart(2, '0')}:${String(time.minute).padStart(2, '0')}`;

export const formatDateISO = (date: Date) => new Rich.SimpleDate(date).toISOString();

export const formatSelectedDate = (date: Date) => {
    const formatted = date.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' });
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

export const formatBookingDate = (date: { year: number; month: number; day: number }) => {
    return new Rich.SimpleDate(date)
        .toDate()
        .toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};
